<template>
  <WhitePage :loading="loading">
    <title-bar>キャラクター管理</title-bar>
    <!-- <result-nav></result-nav> -->
    <div id="manage">
      <select-list
        :items="list"
        :fields="[
          { key: 'eno', label: 'ENo', sortable:true },
          { key: 'icon', label: '' },
          { key: 'name', label: '名前', sortable:true, filterType:'string' },
          { key: 'str', label: 'STR', sortable:true },
          { key: 'int', label: 'INT', sortable:true },
          { key: 'vit', label: 'VIT', sortable:true },
          { key: 'mnd', label: 'MND', sortable:true },
          { key: 'dex', label: 'DEX', sortable:true },
          { key: 'agi', label: 'AGI', sortable:true },
          { key: 'hp', label: 'HP', sortable:true },
          { key: 'area', label: '現在地', filterType:'string' }
        ]"
        :perPage="20"
        tableKey='eno'
        :selectable="false"
        tableClass='manage-table'
      >
        <template v-slot:cell(icon)="row">
          <router-link :to="'/editchara/'+row.item.eno">
            <b-img thumbnail :src="row.item.icon||'./img/noimage.png'" width="60px" height="60px" />
          </router-link>
        </template>
      </select-list>
    </div>

  </WhitePage>
</template>

<script>
import List from '@/views/List'
export default {
  extends: List,
}
</script>

<style lang="scss" scoped>
.eno {
  position: relative;
  top: 20px;
  font-size: medium;
}
#manage ::v-deep .manage-table {
  overflow-x: scroll;

  table {
    width: 1000px;
  }
}
</style>
